import React, { FC } from 'react';
import { GetVosUploadImages_getVosUploadImages as JobImageList } from '../../../types/schemaTypes';
import './vos.scss';
import VosImageItem from './VosImageItem';

interface VosImageListProps {
    images: JobImageList[];
    isLoading: boolean;
    onDelete?: (record: any) => void;
    canEditJobs: boolean;
}

const VosImageList: FC<VosImageListProps> = ({
    images,
  
    isLoading,
    onDelete,
    canEditJobs,
}: VosImageListProps): React.ReactElement => {
    // if (refetch) {
    //     refetch();
    // }

    return (
        <div className="Images-List">
            {images.map((jobImage, index) => (
                <VosImageItem
                    key={jobImage.id ? jobImage.id.toString() : '0'}
                    index={index}
                    image={jobImage}
                    canEditJobs={canEditJobs}
                    onDelete={onDelete}
                ></VosImageItem>
            ))}
        </div>
    );
};

export default VosImageList;

